export const BLOB_CONFIG = {
  "background": "#ffffff",
  "gradientMap": "14",
  "gradientColor1": "#ffffff",
  "gradientColor2": "#ffffff",
  "gradientColor3": "#ffffff",
  "uPositionFrequency": 0.38,
  "uPositionStrength": 0.13,
  "uSmallWavePositionFrequency": 1.15,
  "uSmallWavePositionStrength": 0.22000000000000008,
  "uSmallWaveTimeFrequency": 0.38,
  "uTimeFrequency": 0,
  "roughness": 0.36,
  "metalness": 0,
  "envMapIntensity": 3.15,
  "clearcoat": 0.96,
  "clearcoatRoughness": 0.92,
  "transmission": 0.41000000000000003,
  "wireframe": false,
  "flatShading": true,
  "autoRotate": false,
  "autoRotateSpeed": 1.2
};